var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5321_207060)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#7043FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5321_207060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 27.9995C9.383 27.9995 4 22.6165 4 15.9995C4 9.38251 9.383 3.99951 16 3.99951C22.617 3.99951 28 9.38251 28 15.9995C28 22.6165 22.617 27.9995 16 27.9995ZM16 5.99951C10.486 5.99951 6 10.4855 6 15.9995C6 21.5135 10.486 25.9995 16 25.9995C21.514 25.9995 26 21.5135 26 15.9995C26 10.4855 21.514 5.99951 16 5.99951ZM21 16.9995H11C10.448 16.9995 10 16.5515 10 15.9995C10 15.4475 10.448 14.9995 11 14.9995H21C21.553 14.9995 22 15.4475 22 15.9995C22 16.5515 21.553 16.9995 21 16.9995ZM16 21.9995C15.448 21.9995 15 21.5525 15 20.9995V10.9995C15 10.4475 15.448 9.99951 16 9.99951C16.552 9.99951 17 10.4475 17 10.9995V20.9995C17 21.5525 16.552 21.9995 16 21.9995Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5321_207060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5321_207060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 3.99951)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomInIcon);
export default __webpack_public_path__ + "static/media/zoom_in_icon.3aaea3586324aad52f5441a75ee7b328.svg";
export { ForwardRef as ReactComponent };